import {
    FilterData,
    FilterBlockTypesEnum,
} from "../../src/apis/stateful-content";
const fs = require("fs");
const output = `${__dirname}/../../resources/generated-mock-data/`;

const response: FilterData = {
    filterBlocks: [
        {
            type: FilterBlockTypesEnum.Select,
            name: "assignmentType",
            multiple: true,
            options: [
                {
                    value: "service",
                },
                {
                    value: "maintenance",
                },
                {
                    value: "service_maintenance",
                },
            ],
        },
        {
            type: FilterBlockTypesEnum.Select,
            name: "status",
            multiple: true,
            options: [
                {
                    value: "MISSION_COMPLETED",
                },
                {
                    value: "MISSION_CONFIRMED",
                },
                {
                    value: "MISSION_PROPOSED",
                },
            ],
        },
        {
            type: FilterBlockTypesEnum.Dropdown,
            name: "equipment",
            filterable: true,
            filterItems: [
                {
                    value: "TWDEDEMO028",
                    label:
                        "Maschinenalias TruEquipment 1 (TWDEDEMO028) (6)",
                },
                {
                    value: "TWDEDEMO011",
                    label: "TruEquipmen 2 (TWDEDEMO011) (2)",
                },
                {
                    value: "TWDEDEMO012",
                    label: "TruEquipmen 3 (TWDEDEMO012) (2)",
                },
                {
                    value: "TWDEDEMO013",
                    label: "TruEquipmen 4 (TWDEDEMO013) (2)",
                },
                {
                    value: "TWDEDEMO014",
                    label: "TruEquipmen 5 (TWDEDEMO014) (2)",
                },
                {
                    value: "TWDEDEMO015",
                    label: "TruEquipmen 6 (TWDEDEMO015) (2)",
                },
                {
                    value: "TWDEDEMO016",
                    label: "TruEquipmen 7 (TWDEDEMO016) (2)",
                },
                {
                    value: "TWDEDEMO017",
                    label: "TruEquipmen 8 (TWDEDEMO017) (2)",
                },
                {
                    value: "TWDEDEMO018",
                    label: "TruEquipmen 9 (TWDEDEMO018) (2)",
                },
                {
                    value: "TWDEDEMO019",
                    label: "TruEquipmen 10 (TWDEDEMO019) (2)",
                }
            ],
        },
    ],
};

const writeToFile = (object: FilterData, name: string) => {
    fs.writeFileSync(`${output}${name}.json`, JSON.stringify(object));
};

writeToFile(response, "mymissions-filter");
